import { API_BASE_URL } from '../utils/api';

const qs = (params) =>
  new URLSearchParams(
    Object.entries(params || {}).filter(([, value]) => value !== '' && value != null),
  ).toString();

const request = async (path, options = {}) => {
  const headers = { ...(options.headers || {}) };
  const token = localStorage.getItem('storeToken');

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  let body = options.body;
  if (body && !(body instanceof FormData)) {
    body = JSON.stringify(body);
    headers['Content-Type'] = 'application/json';
  }

  const response = await fetch(`${API_BASE_URL}${path}`, { ...options, headers, body });
  const result = await response.json().catch(() => null);

  if (!response.ok || result?.status !== 'SUCCESS') {
    throw new Error(result?.message || 'Store documents request failed.');
  }

  return { data: result.data, message: result.message };
};

export const listStoreDocuments = (params) => {
  const query = qs(params);
  return request(`/api/store/documents${query ? `?${query}` : ''}`);
};
